import { xor, difference } from 'lodash';
import { startObserveEstimatedTimeUpdates } from 'modules/websocket/actions/estimatedTimeUpdates';
import { fetchAppointmentsEstimatedTime } from 'modules/queues/Schedule/actions/appointmentsEstimatesTimeToBeServed';
import { getAppointmentsEstimatedTimeToBeServedSelector } from 'modules/queues/Schedule/selectors/appointments';


export const resubscribeEstimatedTimeUpdates = (dispatch, getState) => {
  const state = getState();
  const appointmentIds = Object.keys(getAppointmentsEstimatedTimeToBeServedSelector(state));
  const newAppointmentIds = state.queues.schedule.appointments.byId;

  if (difference(newAppointmentIds, appointmentIds).length) {
    dispatch(fetchAppointmentsEstimatedTime());
  }

  if (xor(appointmentIds, newAppointmentIds).length) {
    dispatch(startObserveEstimatedTimeUpdates(newAppointmentIds));
  }
};
